import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme/ThemeContext';

interface PhoneFabProps {
  onNewAppointment: () => void;
  onNewBlock: () => void;
}

/** Google-style floating "+" button that expands into a small speed dial. */
export const PhoneFab: React.FC<PhoneFabProps> = ({ onNewAppointment, onNewBlock }) => {
  const { t } = useTranslation();
  const { tokens } = useTheme();
  const [open, setOpen] = useState(false);

  const pick = (action: () => void) => {
    setOpen(false);
    action();
  };

  const optionStyle: React.CSSProperties = {
    background: tokens.app.surface,
    color: tokens.app.text,
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
  };

  return (
    <>
      {open && <div className="phone-cal-fab-scrim" onClick={() => setOpen(false)} />}
      <div className="phone-cal-fab-wrap">
        {open && (
          <div className="phone-cal-fab-options">
            <button type="button" data-testid="phone-fab-new-block" onClick={() => pick(onNewBlock)} style={optionStyle}>
              {t('responsive.calendar.newBlock')}
            </button>
            <button type="button" data-testid="phone-fab-new-appointment" onClick={() => pick(onNewAppointment)} style={optionStyle}>
              {t('responsive.calendar.newAppointment')}
            </button>
          </div>
        )}
        <button
          type="button"
          className="phone-cal-fab"
          data-testid="phone-calendar-fab"
          aria-label={open ? t('responsive.calendar.close') : t('responsive.calendar.create')}
          aria-expanded={open}
          onClick={() => setOpen(value => !value)}
          style={{ background: tokens.app.primary, color: tokens.app.primaryText }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true" style={{ transform: open ? 'rotate(45deg)' : 'none', transition: 'transform 150ms' }}>
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="currentColor" />
          </svg>
        </button>
      </div>
    </>
  );
};
